import React, {useState, useEffect} from 'react'
import VerAtributos from './VerAtributos'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faSearch, faPrint, faPlusCircle, faPlus } from '@fortawesome/free-solid-svg-icons'
import { SketchPicker } from 'react-color';

const AtributosAdmin = ({baseUrl, Titulo, urlIngredientes}) => {

	//almacena toda la data de categorias 
	const [data, setData] = useState([])
	//almacena el campo Nombre de categoria
	const [nombre, setNombre] = useState('')
	//almacena el campo Nombre de categoria
	const [padre, setPadre] = useState('')
	//almacena el campo activo de categoria
	const [activo, setActivo] = useState(true)
	//almacena la categoria seleccionada
	const [categoriaSelect, setCategoriaSelect] = useState({color: ''})
	//selecciona la función como eliminar, crear, editar
	const [funcion, setFuncion] = useState('cargando')
	//Alerta del error para la validacion de formulario
	const [alerta, setAlerta] = useState(false)

	const [Ingredientes, setIngredientes] = useState([])
	const [ingreSelect, setIngreSelect] = useState({})
	const [checkInvent, setCheckInvent] = useState(false)
	const [color, setColor] = useState('')


	//actualiza el registro de la categoria seleccionada
	const actualizarDato = (dato, name) =>{
		setCategoriaSelect({...categoriaSelect, [name]: dato })
	}

	//hace la consulta y trae las categorias y los almacena en data 
	const peticionTraeDatos = async()=>{
		await axios.get(baseUrl)
		.then (response => {
			setData(response.data)
			setFuncion('ver')
		})

		await axios.get(urlIngredientes)
		.then (response => {
			setIngredientes(response.data)
		})

	}

	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete=async()=>{
	    let f = new FormData();
	    f.append("METHOD", "DELETE");
	    await axios.post(baseUrl, f, {params: {id: categoriaSelect.id}})
	    .then(response=>{
	      setData(data.filter(categoria=>categoria.id!==categoriaSelect.id))
	      setFuncion('ver')
	    }).catch(error=>{
	      console.log(error)
	    })
	  }

	//Selecciona categoria para editarla o borrarla 
	const SeleccionarCategoria = (objeto, funcion) => e => {
		//buscarMedida(objeto.nombre)

		//console.log(objeto)
		setFuncion(funcion)
		setCategoriaSelect({
			id: objeto.id,
			activo: objeto.activo === 'true' ? true : false,
			nombre: objeto.nombre,
			padre: objeto.padre,
			color: objeto.color
		})
		
		//actualizarMedida()
		if(funcion === 'editar'){
			setFuncion('editar')
		}
	}

	//Consulta para editar campos
	const peticionPut=async()=>{
		if(categoriaSelect.nombre !== ''){
		    let f = new FormData()
		    //convierte boleano a cadena
		    let cadena = categoriaSelect.activo ? 'true' : 'false'
		    f.append("activo", cadena)
		    f.append("nombre", categoriaSelect.nombre)
		    f.append("padre", categoriaSelect.padre)
			f.append('color', categoriaSelect.color)
		    f.append("METHOD", "PUT")
		    await axios.post(baseUrl, f, {params: {id: categoriaSelect.id}})
		    .then(response=>{
		      let dataNueva = data
		      dataNueva.map(item=>{
		        if(item.id === categoriaSelect.id){
		          item.activo=cadena
		          item.nombre=categoriaSelect.nombre
		          item.padre=categoriaSelect.padre
				  item.color=categoriaSelect.color
		        }
		      })
		      setData(dataNueva)
		      setFuncion('ver')
		      setAlerta(false)
			  setCheckInvent(false)
		    }).catch(error=>{
		      console.log(error);
		    })
		}else{setAlerta(true)}
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () =>{
		if(nombre !== ''){
			let f = new FormData()
			f.append('activo', activo.toString())
			f.append('nombre', nombre)
			f.append('padre', padre)
			f.append('color', ingreSelect.color)
			f.append('METHOD', 'POST')
			await axios.post(baseUrl, f)

			.then(response=>{
		      setData(data.concat(response.data));
		      setNombre('')
		      setActivo(false)
		      setPadre('')
		      setAlerta('')
		      setFuncion('ver')
			  setCheckInvent(false)
		    }).catch(error=>{
		      console.log(error);
		    })
		}else{setAlerta(true)}
	}

	//Trae todas las categorias de la api
	useEffect(() => {
		peticionTraeDatos()
	},[])

	const handleChangeComplete = (color) => {
		setColor(color.hex)
		setIngreSelect({...ingreSelect, color: color.hex})
	};

	const handleChangeCompleteSelect = (color) => {
		setColor(color.hex)
		setCategoriaSelect({...categoriaSelect, color: color.hex})
	};

	


	return(
		<div>
			<div className="row">
				<div className="col-md-6">
					<br/>
					<h2>{Titulo}:</h2>	
				</div>
				<div className="col-md-6">
					<div className="filtroPedidos">
						<button 
							onClick={e => setFuncion('crear')}
							className="btn boton_estandar btn-lg derecha">
							<FontAwesomeIcon icon={faPlus}/>
						</button>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">

					{funcion === 'editar' ?
						<div>
						<h4>Actualizar Atributo</h4>
						<hr/>
						<div className='custom-control custom-switch '>
					        <input
					          type='checkbox'
					          name="activo"
					          className='custom-control-input form-control-lg mb-4'
					          id='customSwitches'
					          checked={categoriaSelect.activo}
					          onChange={e => actualizarDato(e.target.checked, e.target.name)}
					          readOnly
					        />
					        <label className='custom-control-label' htmlFor='customSwitches'>
					          Activar/Desactivar
					        </label>
			      		</div>
						<MDBInput 
							label="Nombre Atributo" 
							onChange={e => actualizarDato(e.target.value, e.target.name)}
							name="nombre"
							className={alerta ? "form-control is-invalid" : null}
							value={categoriaSelect && categoriaSelect.nombre}
							outline />

						<div>
					        <select 
					        	className="browser-default custom-select selectAtri" 
					        	name="padre"
					        	value={categoriaSelect && categoriaSelect.padre}
					        	onChange={e => actualizarDato(e.target.value, e.target.name)}
					        	>
						          <option value="">Selecciona Atributo Padre</option>
						          {data.map((item, index) => {

						          	if(item.padre === ''){
						          	return(
							          	<option 
							          		key={index}
							          		value={item.nombre}>
							          		{item.nombre}
							          	</option>
						          	)}}
						          )}
						          <option value="">Ninguno</option>
					        </select>
					    </div><br/>

						<div className="col-md-12">
							<div className='custom-control custom-switch '>

									<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='invent'
									checked={checkInvent}
									onChange={e => setCheckInvent(!checkInvent)}
									readOnly
									/>
									<label className='custom-control-label' htmlFor='invent'>Activar Gestión de Color </label>
							</div>
							<br/>
						</div>


						{checkInvent ? 
								<div className="row">

									<div className="col-md-6 sinMargen">
										<MDBInput 
												label={`Color`} 
												value={categoriaSelect.color}
												onChange={e => setCategoriaSelect({...categoriaSelect, color: e.target.value})}
												name="color"
												required
												className={alerta ? "form-control is-invalid" : null}
												outline />
												<div style={{width: '100%', height: 30, borderRadius: 20, backgroundColor: color}}></div>
									</div>
									<div className="col-md-6 sinMargen">
										<SketchPicker
											color={categoriaSelect.color }
											onChangeComplete={ handleChangeCompleteSelect }
										/>
									</div>
								</div>
								
							
						: null}
						<div className="col text-center">
								<button 
									onClick={peticionPut}
									className="btn boton_estandar"							
									>Actualizar Atributo
								</button>
								<button 
									onClick={e=>setFuncion('ver')}
									className="btn boton_estandar"							
									>Cancelar
								</button>
						</div>
						</div>
					: null}

					{funcion === 'crear' ?

						<div>
						<h4>Subir Atributo</h4>
						<hr/>
						<div className='custom-control custom-switch '>
					        <input
					          type='checkbox'
					          name="activo"
					          className='custom-control-input form-control-lg mb-4'
					          id='customSwitches'
					          checked={activo}
					          onChange={e => setActivo(!activo)}
					          readOnly
					        />
					        <label className='custom-control-label' htmlFor='customSwitches'>
					          Activar/Desactivar
					        </label>
			      		</div>
						<MDBInput 
							label="Nombre Atributo" 
							value={nombre}
							onChange={e => setNombre(e.target.value)}
							name="nombre"
							required
							className={alerta ? "form-control is-invalid" : null}
							outline />
						
						<div>
					        <select 
					        	className="browser-default custom-select selectAtri" 
					        	name="padre"
					        	value={padre}
					        	onChange={e => setPadre(e.target.value)}
					        	>
						          <option value="">Selecciona Atributo Padre</option>
						          {data.map((item, index) => {

						          	if(item.padre === ''){
						          	return(
							          	<option 
							          		key={index}
							          		value={item.nombre}>
							          		{item.nombre}
							          	</option>
						          	)}}
						          )}
						          <option value="">Ninguno</option>
					        </select>
					    </div>
					    <br/>

						<div className="col-md-12">
							<div className='custom-control custom-switch '>

									<input type='checkbox' name="activo" className='custom-control-input form-control-lg mb-4' id='invent'
									checked={checkInvent}
									onChange={e => {setCheckInvent(!checkInvent)}}
									readOnly
									/>
									<label className='custom-control-label' htmlFor='invent'>Activar Gestión de Color </label>
							</div>
							<br/>
						</div>

						{checkInvent ? 
							<div className="row">
								<div className="col-md-6 sinMargen">
									<MDBInput 
										label={`Color`} 
										value={ingreSelect.color}
										onChange={e => setIngreSelect({...ingreSelect, color: e.target.value})}
										name="color"
										required
										className={alerta ? "form-control is-invalid" : null}
										outline />
										<div style={{width: '100%', height: 30, borderRadius: 20, backgroundColor: color}}></div>
								</div>
								<div className="col-md-6 sinMargen">
								<SketchPicker
									color={ingreSelect.color }
									onChangeComplete={ handleChangeComplete }
								/>
								</div>
							</div>
							
						: null}
					    <br/>

						<div className="col text-center">
								
							<button 
								onClick={peticionPost}
								className="btn boton_estandar"							
								>Subir Atributo
							</button>
							<button 
									onClick={e=>setFuncion('ver')}
									className="btn boton_estandar"							
									>Cancelar
								</button>
							
						</div>
						</div>
					:null}

					{funcion === 'eliminar' ?

						<div>
						<h4>¿Desea Realmente Eliminar?</h4>
						<hr/>
						<div className="col text-center">

							<p>Categoria: {categoriaSelect.nombre}</p>
							<button 
								onClick={peticionDelete}
								className="btn boton_estandar"							
								>Eliminar
							</button>
							<button 
									onClick={e=>setFuncion('ver')}
									className="btn boton_estandar"							
									>Cancelar
								</button>
							
						</div>
						</div>
					:null}

					{funcion === 'cargando' ? 
						<div className="loader">Loading...</div> 
					:null}

					{funcion === 'ver' ?

						<VerAtributos
							data={data} 
							SeleccionarCategoria={SeleccionarCategoria}
						/>

					:null}
				</div>
			</div>
		</div>
	)
}

export default AtributosAdmin